import { render, staticRenderFns } from "./MailsToSend.vue?vue&type=template&id=7bdb4d3c&scoped=true"
import script from "./MailsToSend.vue?vue&type=script&lang=js"
export * from "./MailsToSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdb4d3c",
  null
  
)

export default component.exports